export default { sha: 'bad235b61adc7f7e91d3a38f4fa206b7c107fa58', buildNumber: 'undefined' }
